import React, { useState } from "react";
import { HardHat } from "lucide-react";
import { SubscribeDialog } from "./SubscribeDialog";

function daysLeft(user) {
  if (typeof user?.demo_days_remaining === "number") return user.demo_days_remaining;
  if (!user?.demo_expires) return 0;
  const ms = new Date(user.demo_expires) - new Date();
  return Math.max(0, Math.ceil(ms / 86400000));
}

export function TrialRibbon({ user }) {
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem("trialRibbonDismissed") === "1"
  );
  const [subOpen, setSubOpen] = useState(false);

  const days = daysLeft(user);
  const expiryStr = user?.demo_expires
    ? new Date(user.demo_expires).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" })
    : "";

  let bg = "bg-amber-500";
  let urgent = false;
  if (days <= 1) {
    bg = "bg-red-600";
    urgent = true;
  } else if (days === 2) {
    bg = "bg-orange-600";
    urgent = true;
  } else if (days <= 3) {
    bg = "bg-amber-600";
  }

  let message;
  if (days <= 1) message = "Last day — subscribe now or your data is deleted tonight.";
  else if (days === 2) message = `2 days left — your data will be deleted on ${expiryStr}.`;
  else if (days <= 3) message = `${days} days left — subscribe to keep your data.`;
  else message = `${days} days remaining in your trial. Data deleted on ${expiryStr}.`;

  const dismiss = () => {
    sessionStorage.setItem("trialRibbonDismissed", "1");
    setDismissed(true);
  };

  if (dismissed) return null;

  return (
    <>
      <div
        className={`${bg} text-white px-4 py-2.5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm`}
        data-testid="trial-ribbon"
      >
        <span className="flex items-center gap-2 font-medium" data-testid="trial-ribbon-message">
          <HardHat className="w-4 h-4" /> {message}
        </span>
        <div className="flex items-center gap-2">
          <button
            onClick={() => setSubOpen(true)}
            className="bg-white text-slate-900 font-semibold px-3 py-1 rounded-full text-xs hover:bg-slate-100"
            data-testid="trial-ribbon-subscribe-btn"
          >
            {urgent ? "Subscribe Now" : "Subscribe"}
          </button>
          <button
            onClick={dismiss}
            className="underline text-white/90 text-xs"
            data-testid="trial-ribbon-continue-btn"
          >
            {days <= 1 ? "Not Today" : "Continue"}
          </button>
        </div>
      </div>
      <SubscribeDialog open={subOpen} onClose={() => setSubOpen(false)} />
    </>
  );
}
